import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { decisioningFactorGroupsQueryKey } from "../decisioning.keys";
import { CATALOG_STALE_TIME_MS } from "./catalog";

const parseFactorGroups = (data: unknown) =>
	Dtos.Decisioning.FactorGroup.Get.Response.schema.array().parse(data);

export const useFetchDecisioningFactorGroups = () => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: decisioningFactorGroupsQueryKey(),
		queryFn: async () =>
			parseFactorGroups(await get<unknown>("/v2/admin/decisioning/factor-groups")),
		staleTime: CATALOG_STALE_TIME_MS,
	});

	return {
		factorGroups: query.data,
		factorGroupsIsLoading: query.isLoading,
		factorGroupsError: query.error,
	};
};
